export const SCROLL_THRESHOLD_PX = 500;
export const ANIMATION_DURATION_MS = 2000;
export const YEARLY_HOURS_SCROLLING = 730;
export const INTERSECTION_THRESHOLD = 0.5;
